import { useQuery } from '@tanstack/react-query'
import { OrderService } from '../services/orderService'

export const useAdminOrders = (status: string) => useQuery({
    queryKey: ['admin-orders', status],
    queryFn: () => OrderService.getAdminOrders(status)
})


export const useAdminOrderItems = (status: string) => useQuery({
    queryKey: ['admin-orders-items', status],
    queryFn: () => OrderService.getAdminOrderItems(status)
})